export const HandleType = {
  GIFT_CARD: "gift-card",
  ORDER_PROTECTION: "navidium-shipping-protection",
  SUBSCRIPTION: "al-luxe",
};
